<template>
  <base-open-card :question="question" :question-name="'משכורת'" :buttons="buttons"/>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseOpenCard from './BaseOpenCard.vue';

export default {
  name: 'SalaryOpenCard',
  components: {
    BaseOpenCard,
  },
  props: {
    question: Object,
  },
  computed: {
    ...mapGetters('cashflowCategoryActions', ['CASHFLOW_CATEGORIES']),
    buttons() {
      return [
        {
          cashflowCategoryAnswer: this.CASHFLOW_CATEGORIES.fixed,
          title: 'זו באמת משכורת',
        },
        {
          cashflowCategoryAnswer: this.CASHFLOW_CATEGORIES.fixed,
          variant: 'secondary',
          title: 'זו הכנסה קבועה',
          subtitle: 'תצפה אותה גם בחודשים הבאים',
        },
        {
          cashflowCategoryAnswer: this.CASHFLOW_CATEGORIES.variable,
          variant: 'secondary',
          title: 'זו הכנסה משתנה',
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/investigations/cashflow-category/cashflow-category/open-cards/SalaryOpenCard.vue